import { SectionBaseModel } from '@/components/layout/section/SectionBaseModel';
import { SectionType } from '@/typings/enums/enums';
import { SettingsData } from '@/typings/interfaces/data/settings/settings';
import { SettingsModel } from '@/components/layout/SettingsModel';
import { SectionSettingsModel } from '@/components/layout/section/SectionSettingsModel';

export class PopoverModel extends SectionBaseModel {
  public getSectionType() {
    return SectionType.POPOVER;
  }

  public getSettingsModel(data: SettingsData): SettingsModel {
    return new SectionSettingsModel(data, this);
  }

  authorSignature(): string {
    return 'Sebastian Jakobsen';
  }

  get index(): number {
    return this.campaignModel.state.popovers.indexOf(this);
  }
}
